import { Route, Routes } from 'react-router-dom';
import type { BalanceSheetJournalEntriesArgs } from './BalanceSheetTableCell';
import { useBalanceSheetTableFilter } from './useBalanceSheetTableFilter';
import { BalanceSheetTable } from './BalanceSheetTable';

export const BalanceSheetRoutes = ({
  children,
  onOpenJournalEntries,
}: {
  children: React.ReactNode;
  onOpenJournalEntries?: (args: BalanceSheetJournalEntriesArgs) => void;
}) => {
  return (
    <Routes>
      <Route path="*" element={children}>
        <Route
          index
          element={<View onOpenJournalEntries={onOpenJournalEntries} />}
        />
        <Route
          path=":type"
          element={<View onOpenJournalEntries={onOpenJournalEntries} />}
        />
      </Route>
    </Routes>
  );
};

const View = ({
  onOpenJournalEntries,
}: {
  onOpenJournalEntries?: (args: BalanceSheetJournalEntriesArgs) => void;
}) => {
  const { filter } = useBalanceSheetTableFilter();

  return (
    <BalanceSheetTable
      key={`balance-sheet-${filter.type}`}
      onOpenJournalEntries={onOpenJournalEntries}
    />
  );
};
